module.exports = __webpack_public_path__ + "static/media/epp.5905eadc.svg";